module.exports = __webpack_public_path__ + "static/media/trustinvest1.47df70e9.jpeg";